(function () {
  var STORAGE_KEY = 'supplystop-project-tool-v1';
  function canUseStorage() {
    try {
      var testKey = STORAGE_KEY + '-test';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function createDefaultState() {
    return {
      version: 1,
      name: 'My Project',
      items: []
    };
  }

  function sanitizeQuantity(value) {
    var qty = parseInt(value, 10);

    if (!Number.isFinite(qty) || qty < 1) {
      return 1;
    }

    return qty;
  }

  function normalizeItem(item) {
    if (!item || !item.variantId) {
      return null;
    }

    return {
      variantId: String(item.variantId),
      productId: item.productId ? String(item.productId) : '',
      title: item.title || 'Untitled product',
      variantTitle: item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '',
      vendor: item.vendor || '',
      url: item.url || '#',
      image: item.image || '',
      price: Number.isFinite(Number(item.price)) ? Number(item.price) : null,
      quantity: sanitizeQuantity(item.quantity),
      available: item.available !== false
    };
  }

  function readState() {
    if (!canUseStorage()) {
      return createDefaultState();
    }

    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);

      if (!raw) {
        return createDefaultState();
      }

      var parsed = JSON.parse(raw);
      var state = createDefaultState();
      state.name = parsed && parsed.name ? String(parsed.name) : state.name;
      state.items = Array.isArray(parsed && parsed.items)
        ? parsed.items.map(normalizeItem).filter(Boolean)
        : [];
      return state;
    } catch (error) {
      return createDefaultState();
    }
  }

  function writeState(state) {
    if (!canUseStorage()) {
      return;
    }

    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  function emitUpdate() {
    document.dispatchEvent(new CustomEvent('project-tool:updated'));
  }

  function saveState(mutator) {
    var state = readState();
    mutator(state);
    state.items = state.items.map(normalizeItem).filter(Boolean);
    writeState(state);
    emitUpdate();
    return state;
  }

  function getTotalQuantity(items) {
    return items.reduce(function (total, item) {
      return total + sanitizeQuantity(item.quantity);
    }, 0);
  }

  function findItemIndex(state, variantId) {
    return state.items.findIndex(function (item) {
      return item.variantId === String(variantId);
    });
  }

  function getCurrentVariantId(button) {
    if (button.dataset.projectSource !== 'product') {
      return String(button.dataset.variantId || '');
    }

    var form = button.closest('form');
    var variantInput = form ? form.querySelector('input[name=\"id\"]') : null;
    return String((variantInput && variantInput.value) || button.dataset.variantId || '');
  }

  function getProductContainer(button) {
    return button.closest('[id^=\"Product-\"]');
  }

  function getVariantJson(button) {
    var productContainer = getProductContainer(button);

    if (!productContainer) {
      return [];
    }

    if (!productContainer.projectToolVariantData) {
      var variantScript = productContainer.querySelector('variant-selects [type=\"application/json\"], variant-radios [type=\"application/json\"]');
      if (!variantScript) {
        productContainer.projectToolVariantData = [];
      } else {
        try {
          productContainer.projectToolVariantData = JSON.parse(variantScript.textContent);
        } catch (error) {
          productContainer.projectToolVariantData = [];
        }
      }
    }

    return productContainer.projectToolVariantData;
  }

  function getCurrentVariant(button) {
    var variantId = getCurrentVariantId(button);
    var variants = getVariantJson(button);

    return variants.find(function (variant) {
      return String(variant.id) === variantId;
    }) || null;
  }

  function getCurrentQuantity(button) {
    var selector = button.dataset.quantitySelector;
    if (!selector) {
      return 1;
    }

    var scope = button.closest('form') || document;
    var input = scope.querySelector(selector);
    return sanitizeQuantity(input && input.value);
  }

  function buildItem(button) {
    var currentVariant = getCurrentVariant(button);
    var item = {
      variantId: getCurrentVariantId(button),
      productId: button.dataset.productId || '',
      title: button.dataset.productTitle || '',
      variantTitle: button.dataset.variantTitle || '',
      vendor: button.dataset.productVendor || '',
      url: button.dataset.productUrl || '#',
      image: button.dataset.productImage || '',
      price: button.dataset.variantPrice ? Number(button.dataset.variantPrice) : null,
      quantity: getCurrentQuantity(button),
      available: button.dataset.variantAvailable !== 'false'
    };

    if (currentVariant) {
      item.variantId = String(currentVariant.id);
      item.variantTitle = currentVariant.title && currentVariant.title !== 'Default Title' ? currentVariant.title : '';
      item.price = Number.isFinite(Number(currentVariant.price)) ? Number(currentVariant.price) : item.price;
      item.available = currentVariant.available !== false;

      if (button.dataset.projectSource === 'product') {
        item.url = window.location.pathname + '?variant=' + currentVariant.id;
      }
    }

    return normalizeItem(item);
  }

  function isVariantSaved(variantId) {
    if (!variantId) {
      return false;
    }

    return findItemIndex(readState(), variantId) !== -1;
  }

  function addOrUpdateItem(item) {
    if (!item) {
      return null;
    }

    return saveState(function (state) {
      var existingIndex = findItemIndex(state, item.variantId);

      if (existingIndex === -1) {
        state.items.push(item);
        return;
      }

      state.items[existingIndex] = Object.assign({}, state.items[existingIndex], item, {
        quantity: state.items[existingIndex].quantity + item.quantity
      });
    });
  }

  function removeItem(variantId) {
    return saveState(function (state) {
      state.items = state.items.filter(function (item) {
        return item.variantId !== String(variantId);
      });
    });
  }

  function updateItemQuantity(variantId, quantity) {
    return saveState(function (state) {
      var index = findItemIndex(state, variantId);

      if (index === -1) {
        return;
      }

      state.items[index].quantity = sanitizeQuantity(quantity);
    });
  }

  function clearItems() {
    return saveState(function (state) {
      state.items = [];
    });
  }

  function formatMoney(cents) {
    if (!Number.isFinite(Number(cents))) {
      return '';
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.shopCurrencyCode || 'USD'
    }).format(Number(cents) / 100);
  }

  function setButtonSavedState(button) {
    var variantId = getCurrentVariantId(button);
    var saved = isVariantSaved(variantId);
    var label = saved ? (button.dataset.savedText || 'Saved to Project') : (button.dataset.defaultText || 'Save to Project');

    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.dataset.variantId = variantId;

    var labelNode = button.querySelector('[data-project-tool-label]');
    if (labelNode) {
      labelNode.textContent = label;
    }
  }

  function syncButtons(scope) {
    (scope || document).querySelectorAll('[data-project-tool-button]').forEach(setButtonSavedState);
  }

  function syncCountBadges() {
    var total = getTotalQuantity(readState().items);

    document.querySelectorAll('[data-project-tool-count-badge]').forEach(function (badge) {
      badge.textContent = total;
      badge.hidden = total < 1;
    });
  }

  function showStatus(container, message, isError) {
    if (!container) {
      return;
    }

    container.hidden = false;
    container.classList.toggle('is-error', !!isError);
    container.innerHTML = message;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderItemsMarkup(items) {
    return items.map(function (item) {
      var imageMarkup = item.image
        ? '<a class=\"project-tool-item-image\" href=\"' + item.url + '\"><img src=\"' + item.image + '\" alt=\"' + escapeHtml(item.title) + '\" loading=\"lazy\" decoding=\"async\"></a>'
        : '<div class=\"project-tool-item-image\" aria-hidden=\"true\"></div>';

      return [
        '<article class=\"project-tool-item\" data-project-item data-variant-id=\"' + item.variantId + '\">',
        imageMarkup,
        '<div class=\"project-tool-item-details\">',
        item.vendor ? '<div class=\"project-tool-item-vendor\">' + escapeHtml(item.vendor) + '</div>' : '',
        '<h2 class=\"project-tool-item-title\"><a href=\"' + item.url + '\">' + escapeHtml(item.title) + '</a></h2>',
        item.variantTitle ? '<div class=\"project-tool-item-variant\">' + escapeHtml(item.variantTitle) + '</div>' : '',
        item.price !== null ? '<div class=\"project-tool-item-price\">' + formatMoney(item.price) + '</div>' : '',
        '<div class=\"project-tool-item-controls\">',
        '<label class=\"project-tool-item-qty\">Qty<input type=\"number\" min=\"1\" value=\"' + item.quantity + '\" data-project-tool-qty-input data-variant-id=\"' + item.variantId + '\"></label>',
        '<button type=\"button\" class=\"project-tool-remove\" data-project-tool-remove data-variant-id=\"' + item.variantId + '\">Remove</button>',
        '</div>',
        '</div>',
        '</article>'
      ].join('');
    }).join('');
  }

  function renderProjectRoots() {
    var roots = document.querySelectorAll('[data-project-tool-root]');
    if (!roots.length) {
      return;
    }

    var state = readState();
    var items = state.items;
    var totalQuantity = getTotalQuantity(items);
    var listMarkup = items.length ? renderItemsMarkup(items) : '';

    roots.forEach(function (root) {
      var list = root.querySelector('[data-project-tool-list]');
      var empty = root.querySelector('[data-project-tool-empty]');
      var summary = root.querySelector('[data-project-tool-summary]');
      var actions = root.querySelector('[data-project-tool-actions]');

      if (summary) {
        summary.textContent = items.length
          ? totalQuantity + ' saved item' + (totalQuantity === 1 ? '' : 's')
          : 'No items saved yet';
      }

      if (empty) {
        empty.hidden = items.length > 0;
      }

      if (actions) {
        actions.hidden = items.length < 1;
      }

      if (list) {
        list.innerHTML = listMarkup;
      }
    });
  }

  function getCartAddEndpoint() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.endsWith('.js') ? base : base + '.js';
  }

  function addAllToCart(page) {
    var status = page.querySelector('[data-project-tool-status]');
    var items = readState().items.map(function (item) {
      return {
        id: String(item.variantId),
        quantity: sanitizeQuantity(item.quantity)
      };
    });

    if (!items.length) {
      showStatus(status, 'Save a few products first, then you can add them all to cart.', true);
      return;
    }

    showStatus(status, 'Adding saved items to cart...', false);

    var endpoint = getCartAddEndpoint();
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var requests = items.map(function (item) {
      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(item)
      }).then(function (response) {
        if (response.ok) {
          return response.json();
        }

        return response.json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            var message = data && (data.description || data.message);
            throw new Error(message || 'Unable to add items to cart.');
          });
      });
    });

    Promise.all(requests)
      .then(function () {
        window.location.href = cartUrl;
      })
      .catch(function (error) {
        showStatus(
          status,
          (error && error.message) ? error.message : 'There was a problem adding those items to cart. Please try again.',
          true
        );
      });
  }

  function getDrawer() {
    return document.querySelector('[data-project-tool-drawer]');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) {
      return;
    }

    drawer.hidden = false;
    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) {
      return;
    }

    drawer.hidden = true;
    document.body.classList.remove('overflow-hidden');
  }

  function getActiveStatusContainer() {
    var drawer = getDrawer();
    if (drawer && !drawer.hidden) {
      return drawer.querySelector('[data-project-tool-status]');
    }

    var pageRoot = document.querySelector('[data-project-tool-page]');
    return pageRoot ? pageRoot.querySelector('[data-project-tool-status]') : null;
  }

  function onDocumentClick(event) {
    var openTrigger = event.target.closest('[data-project-tool-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer();
      return;
    }

    var closeTrigger = event.target.closest('[data-project-tool-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var button = event.target.closest('[data-project-tool-button]');
    if (button) {
      event.preventDefault();

      var item = buildItem(button);
      if (!item) {
        return;
      }

      var statusContainer = getActiveStatusContainer();

      if (isVariantSaved(item.variantId)) {
        removeItem(item.variantId);
        if (statusContainer) {
          showStatus(statusContainer, 'Removed ' + escapeHtml(item.title) + ' from your project.', false);
        }
      } else {
        addOrUpdateItem(item);
        if (statusContainer) {
          showStatus(statusContainer, 'Saved ' + escapeHtml(item.title) + ' to your project.', false);
        }
      }

      return;
    }

    var removeButton = event.target.closest('[data-project-tool-remove]');
    if (removeButton) {
      event.preventDefault();
      removeItem(removeButton.dataset.variantId);
      return;
    }

    var clearButton = event.target.closest('[data-project-tool-clear]');
    if (clearButton) {
      event.preventDefault();
      clearItems();
      var clearRoot = clearButton.closest('[data-project-tool-root]');
      if (clearRoot) {
        showStatus(clearRoot.querySelector('[data-project-tool-status]'), 'Project cleared.', false);
      }
      return;
    }

    var addAllButton = event.target.closest('[data-project-tool-add-all]');
    if (addAllButton) {
      event.preventDefault();
      var root = addAllButton.closest('[data-project-tool-root]');
      if (root) {
        addAllToCart(root);
      }
    }
  }

  function onDocumentChange(event) {
    var quantityInput = event.target.closest('[data-project-tool-qty-input]');
    if (quantityInput) {
      updateItemQuantity(quantityInput.dataset.variantId, quantityInput.value);
      return;
    }

    if (event.target.matches('input[name=\"id\"]')) {
      syncButtons(document);
    }
  }

  function onDocumentKeydown(event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  }

  function initialize() {
    if (!canUseStorage()) {
      return;
    }

    syncButtons(document);
    syncCountBadges();
    renderProjectRoots();

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('change', onDocumentChange);
    document.addEventListener('keydown', onDocumentKeydown);
    document.addEventListener('project-tool:updated', function () {
      syncButtons(document);
      syncCountBadges();
      renderProjectRoots();
    });
    document.addEventListener('variant:change', function () {
      syncButtons(document);
    });

    if (window.location.hash === '#projects') {
      openDrawer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
